export default "__VITE_ASSET__ff138d3e__"